/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Large_Json_Files_S3_Li2Inputs */

const en_guide_large_json_files_s3_li2 = /** @type {(inputs: Guide_Large_Json_Files_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Python</strong>: Use <code>ijson</code> for iterative JSON parsing`)
};

const ko_guide_large_json_files_s3_li2 = /** @type {(inputs: Guide_Large_Json_Files_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Python</strong>: 반복적 JSON 파싱을 위해 <code>ijson</code> 사용`)
};

const ja_guide_large_json_files_s3_li2 = /** @type {(inputs: Guide_Large_Json_Files_S3_Li2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`<strong>Python</strong>: 反復的なJSONパースに<code>ijson</code>を使用`)
};

/**
* | output |
* | --- |
* | "<strong>Python</strong>: Use <code>ijson</code> for iterative JSON parsing" |
*
* @param {Guide_Large_Json_Files_S3_Li2Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_large_json_files_s3_li2 = /** @type {((inputs?: Guide_Large_Json_Files_S3_Li2Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Large_Json_Files_S3_Li2Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_large_json_files_s3_li2(inputs)
	if (locale === "ko") return ko_guide_large_json_files_s3_li2(inputs)
	return ja_guide_large_json_files_s3_li2(inputs)
});